import CTA from '@/components/cta';

import { BackgroundColor } from '@/enums/background-color';
import { routes } from '@/utils/route-utils';

export default function RegisterCTA() {
  return (
    <CTA
      title={`Join Nomad's travel nurse community`}
      link={{
        href: routes.register(),
        children: 'Sign Up',
      }}
      full
      backgroundColor={BackgroundColor.PRIMARY_LIGHT}
    />
  );
}
